<template>
  <div>
    <div class="add_main">
      <el-form label-position="left" label-width="150px">
        <el-form-item label="应用名称">
          <el-input
            v-model="add.data.name"
            class="add_input"
            placeholder="请输入应用名称"
            autocomplete="off"
            width="50%"
          />
        </el-form-item>
        <el-form-item label="应用id">
          <el-input
            v-model="add.data.type_id"
            class="add_input"
            placeholder="请输入应用id"
            autocomplete="off"
            width="50%"
          />
        </el-form-item>
        <el-form-item label="授权唯一标识">
          <el-input
            v-model="add.data.app_code"
            class="add_input"
            placeholder="请输入授权唯一标识"
            autocomplete="off"
            width="50%"
          />
          <el-tag type="info">登陆https://ch.open.qq.com/static 获取</el-tag>
        </el-form-item>
        <el-form-item label="媒体账号">
          <el-select v-model="add.data.advertiser_id" placeholder="请选择媒体账号" clearable>
            <el-option
              v-for="(item, index) in medias_list"
              :key="index"
              :label="item.advertiser_name"
              :value="item.advertiser_id.toString()"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="平台">
          <el-select v-model="add.data.plf_id" placeholder="请选择平台" clearable>
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="parseInt(item.value)"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="addCancel">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </div>
</template>

<script>
// 请求用户列表的接口
import AppsResource from '@/api/apps';
const appsResource = new AppsResource();
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();
export default {
  props: {
    type: { type: String, default: 'add' },
    data: {
      type: Object,
      default: () => {
        return;
      },
    },
  },
  data() {
    return {
      medias_list: [],
      options: [
        {
          value: '0',
          label: 'web',
        },
        {
          value: '1',
          label: 'ios正版',
        },
        {
          value: '2',
          label: 'ios越狱',
        },
        {
          value: '3',
          label: 'android',
        },
      ],
      add: {
        loading: false,
        data: {
          name: '',
          type_id: '',
          app_code: '',
          advertiser_id: '',
          advertiser: 'gdt',
          plf_id: '',
        },
      },
    };
  },
  created() {
    this.getMediasList();
    if (this.type === 'edit') {
      this.add.data = this.data;
      for (const k in this.data) {
        for (const v in this.add.data) {
          if (k === v) {
            this.add.data[k] = this.data[v];
          }
        }
      }
      this.edit_id = this.data.id;
    }
  },
  methods: {
    // 获取媒体账号
    async getMediasList() {
      const params = {
        type: 'gdt',
        page: 1,
        limit: 15,
        is_list: true,
      };
      const { list } = await mediasResource.getMediasListApi(params);
      this.medias_list = list;
    },

    // 确认新增
    async addConfirm() {
      const {
        data: { name, type_id, app_code, advertiser_id, plf_id },
      } = this.add;

      if (name === '') {
        this.$message({
          message: '应用名称不能为空',
          type: 'warning',
        });
        return;
      }

      if (type_id === '') {
        this.$message({
          message: '应用id不能为空',
          type: 'warning',
        });
        return;
      }

      if (plf_id === '') {
        this.$message({
          message: '平台不能为空',
          type: 'warning',
        });
        return;
      }

      if (app_code === '') {
        this.$message({
          message: '授权唯一标识不能为空',
          type: 'warning',
        });
        return;
      }

      if (advertiser_id.length === 0) {
        this.$message({
          message: '媒体账号不能为空',
          type: 'warning',
        });
        return;
      }
      // 新增应用
      if (this.type === 'add') {
        this.add.loading = true;
        await appsResource
          .addApp(this.add.data)
          .then((response) => {
            this.$message({
              message: '添加应用成功',
              type: 'success',
            });
            this.$emit('config');
          })
          .catch((error) => {
            console.log(error);
          });
        this.add.loading = false;
      } else {
        // 编辑应用
        this.add.loading = true;
        await appsResource
          .editApp(this.add.data, this.edit_id)
          .then((response) => {
            this.$message({
              message: '编辑成功成功',
              type: 'success',
            });
            this.$emit('config');
          })
          .catch((error) => {
            console.log(error);
          })
          .then(() => {
            this.add.loading = false;
          });
      }
    },

    // 取消新增
    addCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-input,
.el-select {
  width: 350px !important;
}
.dialog-footer {
  display: block;
  text-align: center;
}
.tree {
  float: left;
  width: 100%;
}
</style>
